import(/* webpackMode: "eager", webpackExports: ["AnimatedCollections"] */ "/vercel/path0/app/collections/animated-collections.tsx");
